import {Intent, PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';
import React from 'react';
import ReactTooltip from 'react-tooltip'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

import Form from '../../../components/common/Form';

import axios from "axios";
import * as authService from '../../../services/authService';
import {getCurrentUserId, getJwt} from "../../../services/authService";
import InfoCircle from '../../common/InfoCircle';
import {persistent_menu, persistent_menu_start_it, persistent_menu_telegraf} from "../../constants/constants";

import http from "../../../services/httpService";
import toastr from 'toastr';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';
// import ReactGA from "react-ga";
import ConnectBotToPageModal from '../../modals/ConnectBotToPageModal';
import DeleteRssModal from '../../modals/DeleteRssModal';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;

class FbMessengerChannels extends Form {
    constructor(props) {
        super(props);
        this.state = {
            clicked_fb: false,
            clicked_wp: false,
            clicked_viber: false,
            fb_spinner: false,
            spinnerActive: false,
            clickedFbPageConnect: '',
            user: {
                facebook_pages_shared: props.facebook_pages_shared || [],
                facebook_pages:
                    {
                        data: props.facebook_pages || []
                    },
                missing_allowed_pages: []
            },
            copiedToClipboard: false,
            pageName: '',
            disconnectPageModalActive: false,
            disconnectPageModalData: {}
        };
        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    handleDisconnectShow = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot",e.target.slot);
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        if (e.target.slot) {
            const targetFade = '#' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$(this).toggleClass('opened');
        //$('.platform-edit .platform-dropdown').fadeToggle();
        //$('#'+e.target).fadeToggle();
    };

    //handleInfoCircle = () => {
    //    $('#forbidden > .team-user-panel').fadeToggle()
    //};

    handleInfoCircle = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot", e.target.slot);
        if (e.target.slot) {
            const targetFade = '.forbidden > #' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$('#forbidden > .team-user-panel').fadeToggle()
        //$('#forbidden > .team-user-panel').fadeToggle()
    };

    handleClosePanel = () => {
        $('#forbidden > .team-user-panel').fadeToggle()
    };

    toggleWP = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dist platform - Enabled Webpush',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        // console.log("PlatformsSupported toggleWP this.state.clicked_wp",this.state.clicked_wp);
        this.setState({clicked_wp: !this.state.clicked_wp, fb_spinner: true});
        await this.props.enablePlatform(e);

        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});

            // this.props.updateSources(result.data);
            this.props.updateUser();
            this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
        } else if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});
            this.props.updateUser();
            // this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }
        this.setState({fb_spinner: false})
    };

    toggleFB = async (e) => {
        //console.log("PlatformsSupported toggleFB this.state.clicked_fb",this.state.clicked_fb);
        await this.setState({clicked_fb: !this.state.clicked_fb});
        await this.props.enablePlatform(e);
        //this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        if (typeof (this.props.appPropagateUserPlatforms) !== 'undefined') {
            this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        }
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }

    };

    toggleConnect = async (e) => {

        this.setState({
            clickedFbPageConnect: e.target.id,
            spinnerActive: true
        })
        const FB_URL = facebook_app_graph_url;
        let pg_id = e.target.id;
        let pg_token = e.target.attributes.value.nodeValue;
        let feed_id = e.target.attributes.name.nodeValue;
        let page_connected = e.target.title;


        let source_rss = this.props.source_rss;

        //console.log("toggleConnect  appPropagateUserData={this.props.appPropagateUserData}", this.props.appPropagateUserData);

        var url_facebook_graph = FB_URL + pg_id + '/subscribed_apps?access_token=' + pg_token.toString() + '&subscribed_fields=messages,message_deliveries,messaging_optins,messaging_postbacks';

        var url_facebook_get_started = FB_URL + 'me/thread_settings?access_token=' + pg_token;
        var url_facebook_menu = FB_URL + 'me/messenger_profile?access_token=' + pg_token;

        var headers_get_started = {ContentType: "application/json"};

        let paramsToSend = {}

        try {
            if (page_connected !== "Connected") {
                try {
                    const result = await axios.post(url_facebook_graph, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'undefined'
                        }
                    });

                    // console.log("toggleConnect url_facebook_graph result", result);
                    if (!result) {
                        toastr.error("Facebook api connecting app problem. :(  Please log in again.");
                        this.setState({spinnerActive: false})
                    } else {
                        // try {
                        //     const result = await axios.post(url_facebook_get_started, {
                        //         "get_started":{
                        //         "payload":"GET_STARTED_PAYLOAD"
                        //     }});
                        // } catch(e){
                        //
                        // }

                        page_connected = "Connected";
                        if (this.props.onlypage) {
                            //console.log(feed_id);
                            //console.log("this.props.name", this.props.name);

                            //console.log("this.props.onlypage", this.props.onlypage);
                            if (feed_id === "page_source") {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id,
                                    name: this.props.name,
                                    team_name: this.props.team_name,
                                    onlypage: this.props.onlypage
                                };
                                this.setState({spinnerActive: false})
                            } else {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id
                                };
                                this.setState({spinnerActive: false})
                            }

                        } else {
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id
                            };
                        }
                        //console.log("paramsToSend ", paramsToSend);


                        var url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        var headers_def = {authorization: getJwt()};

                        var params_start = {
                            "setting_type": "call_to_actions",
                            "thread_state": "new_thread",
                            "call_to_actions": [
                                {
                                    "payload": "Start"
                                }
                            ]
                        };

                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = await res.data.data;
                            await this.props.enablePlatform({
                                target: {
                                    id: "fb_enable",
                                    title: this.props.sourceId.toString()
                                }
                            });
                            this.props.activateFeed({target: {id: this.props.sourceId.toString(), name: 'activate'}});
                            // console.log("toggleConnect url_api", data);
                            if (!data) {
                                toastr.error("res id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({user: data});
                                this.props.appPropagateUserData(data);
                                //console.log("toggleConnecttoggleConnecttoggleConnecttoggleConnect data", data);
                                const id = data.sources.data[0].id;
                                localStorage.setItem("source_clicked", JSON.stringify(id.toString()));
                                // localStorage.setItem("feed_id", JSON.stringify(id.toString()));

                                // try {
                                //     const res_get_started = await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_get_started", res_get_started);
                                //     if (res_get_started) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //
                                //     if (ex.response && ex.response.status === 403) {
                                //         toastr.error(ex.response.data.error.message);
                                //         //if(missing_permissions.length===0)
                                //         //{
                                //         //    alert("Please, go to https://www.facebook.com/settings?tab=business_tools&section=active    and " +
                                //         //        "recheck allowed permissions for this page. " +
                                //         //        "Both manage_pages and pages_messaging permissions have to be granted for this page. " +
                                //         //        "After this LOGIN via FACEBOOK into Emitto, for changes to take effect.");
                                //         //}
                                //     }
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }

                                let params_persistent_menu = persistent_menu;
                                if (source_rss.includes('telegraf')) {
                                    params_persistent_menu = persistent_menu_telegraf;
                                } else if (source_rss.includes('startit') || source_rss.includes('nolimithub')) {
                                    params_persistent_menu = persistent_menu_start_it;
                                }
                                try {
                                    const res_facebook_menu = await axios.post(url_facebook_menu, params_persistent_menu, {headers: headers_get_started});
                                    //console.log("toggleConnect res_facebook_menu", res_facebook_menu);
                                    if (res_facebook_menu) {

                                    }
                                } catch (ex) {
                                    //console.log("ex.response", ex.response);
                                    this.setState({spinnerActive: false})
                                    if (ex.response && ex.response.status === 404)
                                        toastr.error("Something went wrong... Please refresh and try again.");
                                    if (ex.response && ex.response.status === 403)
                                        toastr.error(ex.response.data.error.message);
                                    if (ex.response && ex.response.status === 401) {
                                        //let errors = { ...this.state.errors }
                                        //console.log(ex.response.data);
                                        toastr.error(ex.response.data.message);
                                        //window.location = "/";
                                        this.props.history.push('/logout');
                                    }
                                }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            this.setState({spinnerActive: false})
                            if (ex.response && ex.response.status === 404)
                                toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }
                } catch (ex) {
                    this.setState({spinnerActive: false})
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }


            } else {

                try {
                    // console.log("pre toggleConnect delete(url_facebook_graph result");
                    const res_facebook_menu = await axios.delete(url_facebook_menu, {
                        headers: headers_get_started,
                        data: {
                            "fields": [
                                "get_started",
                                "persistent_menu"
                            ]
                        }
                    });

                    if (res_facebook_menu) {
                        const result = http.delete(url_facebook_graph);
                        // console.log("toggleConnect delete(url_facebook_graph result", result);

                        if (!result) {
                            toastr.error("Facebook api disconnecting app problem.. :(  Please log in again.");
                        } else {
                            page_connected = "Not Connected";
                            if (this.props.onlypage) {
                                //console.log(feed_id);
                                //console.log("this.props.name", this.props.name);
                                //console.log("this.props.onlypage", this.props.onlypage);
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id,
                                    name: this.props.name,
                                    team_name: this.props.team_name,
                                    onlypage: this.props.onlypage
                                };
                                //console.log("paramsToSend ", paramsToSend);
                            } else {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id
                                };
                            }

                            url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                            headers_def = {authorization: getJwt()};
                            try {
                                const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                                const data = res.data.data;
                                //console.log("toggleConnect delete-patch(url_api data", data);
                                if (!data) {
                                    toastr.error("res removing id does not match. :(  Please log in again.");
                                    this.props.history.push('/logout');
                                } else {
                                    //let user = data;
                                    this.setState({user: data, spinnerActive: false});
                                    //let rmv_persistent_menu = {
                                    //    "fields":[
                                    //        "persistent_menu"
                                    //    ]
                                    //};

                                    // try {
                                    //     const data_rmv_persistent_menu = await axios.delete(url_facebook_menu, {
                                    //         params: {
                                    //             "fields": [
                                    //                 "persistent_menu"
                                    //             ]
                                    //         }
                                    //     }, {headers: headers_get_started});
                                    //     //console.log("toggleConnect delete(url_facebook_menu data_rmv_persistent_menu", data_rmv_persistent_menu);
                                    //     if (data_rmv_persistent_menu) {
                                    //
                                    //     }
                                    // } catch (ex) {
                                    //     //console.log("ex.response", ex.response);
                                    //     if (ex.response && ex.response.status === 404)
                                    //         toastr.error("Something went wrong... Please refresh and try again.");
                                    //     if (ex.response && ex.response.status === 403)
                                    //         toastr.error("DELETING persistent_menu ERROR - " + ex.response.data.error.message);
                                    //     if (ex.response && ex.response.status === 401) {
                                    //         //let errors = { ...this.state.errors }
                                    //         //console.log(ex.response.data);
                                    //         toastr.error(ex.response.data.message);
                                    //         //window.location = "/";
                                    //         this.props.history.push('/logout');
                                    //     }
                                    // }
                                }
                            } catch (ex) {
                                //console.log("ex.response", ex.response);
                                if (ex.response && ex.response.status === 404)
                                    toastr.error("Something went wrong... Please refresh and try again.");
                                if (ex.response && ex.response.status === 403)
                                    toastr.error(ex.response.data.error.message);
                                if (ex.response && ex.response.status === 401) {
                                    //let errors = { ...this.state.errors }
                                    //console.log(ex.response.data);
                                    toastr.error(ex.response.data.message);
                                    //window.location = "/";
                                    this.props.history.push('/logout');
                                }
                            }
                        }
                    }

                } catch (ex) {
                    // console.log("ex.response", ex.response);
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 403)
                        toastr.error("DELETING ERROR - " + ex.response.data.error.message);
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                    if (ex.response && ex.response.data && ex.response.data.error && ex.response.data.error.message) {
                        toastr.error(ex.response.data.error.message);
                    }
                }

            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                //let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                //window.location = "/";
                this.props.history.push('/logout');
            }
        }

    };

    responseFacebookForSourceEnable = async (response) => {
        try {
            await this.setState({
                fb_spinner: true
            });
            if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
                if (response.name !== "" && (typeof (response.name) !== 'undefined')) {

                    // console.log("responseFacebook response ", response);

                    let feed_id = await this.props.sourceId;
                    if (feed_id === "page_source") {
                        feed_id = ""
                    }
                    let login_facebook_response = {};
                    // console.log("PlatformsSupported responseFacebookForSourceEnable this.props ", this.props);
                    if (response.email && response.email !== "") {
                        login_facebook_response = await http.post('api/login_facebook/' + feed_id, response, {headers: {authorization: getJwt()}});
                        await this.props.enablePlatform({
                            target: {
                                id: "fb_enable",
                                title: this.props.sourceId.toString()
                            }
                        });
                        await this.setState({clicked_fb: true});

                        //console.log('responseFacebook login_facebook_response', login_facebook_response)

                        // Update user
                        const data = await login_facebook_response.data ? login_facebook_response.data.data : "";
                        const missing_allowed_pages = await login_facebook_response.data.missing_allowed_pages.filter(page => page.connected)
                        if (data) {
                            await this.setState({
                                user: Object.assign(
                                    {},
                                    this.state.user,
                                    {
                                        facebook_pages: data.facebook_pages,
                                        facebook_pages_shared: data.facebook_pages_shared,
                                        missing_allowed_pages
                                    }
                                )
                            });
                            await this.props.updateUser({
                                facebook_pages: data.facebook_pages,
                                facebook_pages_shared: data.facebook_pages_shared,
                                missing_allowed_pages
                            })
                        }
                        /* Updating platforms_enabled */
                        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {

                            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});
                            let platformsEnabled = await result.data.platforms_enabled

                            await this.props.updateSources(result.data);
                            await this.props.selectSource({
                                id: result.data.id,
                                source_active: true,
                                selected_source_rss: result.data.rss
                            })
                        }
                    } else {
                        toastr.error("Email obtain permission has to be checked in order to register!")
                    }
                }
                await this.setState({
                    fb_spinner: false
                });
            } else {
                toastr.error("Facebook response undefined! Please try later, or,  try standard register approach instead.")
            }
        } catch (ex) {
            await this.setState({
                fb_spinner: false
            });
        }


    };

    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token) => {
        if (user_fb_id && user_fb_extended_token) {
            try {
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token);
                const fbAdsManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'ads_management');
                /* changed to 'ads_management' from from 'pages_manage_ads' */
                const fbManagePagesPermission = await fbUserPermissions.data.data.find(item => item.permission === 'pages_messaging');
                if (fbAdsManagementPermission) {
                    await this.setState({
                        fbAdsManagementPermission: (fbAdsManagementPermission.status === 'granted') ? true : false
                    })
                }
                if (fbManagePagesPermission) {
                    await this.setState({
                        fbManagePagesPermission: (fbManagePagesPermission.status === 'granted') ? true : false
                    })
                }
                // console.log('Permisije, permisije: ', fbUserPermissions, this.state.fbAdsManagementPermission, this.state.fbManagePagesPermission)
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                if (ex.response && ex.response.status === 401) {
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                }
            }
        }
    }

    componentDidUpdate = async () => {

        let {
            sourceId,
            onlypage,
            facebook_pages,
            platforms_enabled,
            facebook_pages_shared,
            feedActiveUpdateOnChange
        } = this.props;

        if (this.state.spinnerActive) {
            this.setState({spinnerActive: false});
        }

        if (facebook_pages !== this.props.facebook_pages || facebook_pages_shared !== this.props.facebook_pages_shared) {
            facebook_pages = this.props.facebook_pages;
            let user = {
                ...this.state.user,
                facebook_pages: {
                    data: this.props.facebook_pages
                },
                facebook_pages_shared: this.props.facebook_pages_shared,
            };
            this.setState({user: user});

        }
        if (this.state.sourceId !== this.props.sourceId) {
            sourceId = this.props.sourceId;
            onlypage = this.props.onlypage;

        }
        if (this.state.platforms_enabled !== this.props.platforms_enabled) {
            platforms_enabled = this.props.platforms_enabled;

        }
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;

        //let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;
        // console.log("Platfom Supported- will recieve props - platforms_enabled ", platforms_enabled);
        //let facebook_pages = this.props.facebook_pages;

        let count_pages = facebook_pages ? facebook_pages.length : "";

        let page_source_connected = (count_pages && sourceId) ? facebook_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === sourceId.toString())
        }) : "";
        // if (page_source_connected.length || facebook_platform_enabled) {
        //     this.setState({clicked_fb: true});
        //
        // } else {
        //     this.setState({clicked_fb: false});
        // }

    }

    componentDidMount() {
        //console.log("componentDidMount PlatformsSupported, this.props",this.props);
        let {user: userData, sourceId, facebook_pages, platforms_enabled, facebook_pages_shared} = this.props;
        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        this.setState({user: user});
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let count_pages = facebook_pages ? facebook_pages.length : "";
        let page_source_connected = (count_pages && sourceId) ? facebook_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === sourceId.toString())
        }) : "";
        // console.log("Platfom Supported- will mount - platforms_enabled ", platforms_enabled);
        // if (page_source_connected.length || facebook_platform_enabled) {
        //     this.setState({clicked_fb: true});
        //
        // } else {
        //     this.setState({clicked_fb: false});
        // }
        this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token);
    }

    responseFacebookForSource = async (response) => {
        if (response.status !== 'unknown' || (typeof (response.status) !== 'undefined')) {
            if (response.name !== "" && (typeof (response.name) !== 'undefined')) {
                // console.log("responseFacebook response ", response);
                await this.props.permissionsChangeMade();
                let feed_id = this.props.sourceId;
                let login_facebook_response = {};
                if (response.email && response.email !== "") {
                    if (feed_id === "page_source") {
                        login_facebook_response = await http.post('api/login_facebook', response, {headers: {authorization: getJwt()}});
                        // console.log("responseFacebook login_facebookf ", login_facebook_response);
                    } else {
                        login_facebook_response = await http.post('api/login_facebook/' + feed_id, response, {headers: {authorization: getJwt()}});
                        // console.log("responseFacebook login_facebookid ", login_facebook_response);
                    }
                    //await http.post('api/login_facebook/' + feed_id, response);
                    await this.props.enablePlatform({target: {id: "fb_enable", title: this.props.sourceId.toString()}});
                    this.setState({clicked_fb: true});
                    const data = login_facebook_response.data ? login_facebook_response.data.data : "";
                    const missing_allowed_pages = login_facebook_response.data.missing_allowed_pages.filter(page => page.connected)
                    if (!data) {
                        toastr.error("Retrieving user data problem. :(  Please log in again.");
                        this.props.history.push('/logout');
                    } else {
                        this.setState({
                            user: Object.assign(
                                {},
                                this.state.user,
                                {
                                    facebook_pages: data.facebook_pages,
                                    facebook_pages_shared: data.facebook_pages_shared,
                                    missing_allowed_pages
                                }
                            )
                        });
                        await this.props.updateUser({
                            facebook_pages: data.facebook_pages,
                            facebook_pages_shared: data.facebook_pages_shared
                        })
                    }
                    /* Updating platforms_enabled */
                    if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {

                        let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});
                        let platformsEnabled = await result.data.platforms_enabled

                        this.props.updateSources(result.data);
                        this.props.selectSource({id: result.data.id, source_active: true})
                    }

                } else {
                    toastr.error("Email obtain permission has to be checked in order to register!")
                }
            }
        } else {
            toastr.error("Facebook response undefined! Please try later, or,  try standard register approach instead.")
        }

    };

    copyStringToClipboard = (stringValue) => {
        // Create new element
        var el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = stringValue;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
        if (stringValue) {
            this.setState({
                copiedToClipboard: true
            })
            setTimeout(() => {
                this.setState({copiedToClipboard: false})
            }, 5000)
        }
    }


    render() {
        let {
            openModal,
            onlypage,
            web_push_id,
            fromDistributionPlatforms,
            user,
            sourceId,
            source_rss,
            platforms_enabled,
            onClick,
            activateFeed,
            appPropagateUserData,
            website,
            enablePlatform,
            updateUser,
            updateSources,
            selectSource,
            feedActiveUpdateOnChange
        } = this.props;
        let show_disconnect = true;
        if (typeof (openModal) === 'undefined') {
            show_disconnect = false;
        }
        const {
            clicked_fb,
        } = this.state;
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;

        // {console.log('Messenger enable button: ', facebook_platform_enabled, platforms_enabled)}

        let facebook_pages = this.state.user.facebook_pages.data;
        let facebook_pages_shared = this.state.user.facebook_pages_shared;

        let count_pages = 0;
        let count_pages_shared = 0;
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        if (typeof (facebook_pages) !== 'undefined') {
            count_pages = facebook_pages.length;
        }
        if (typeof (facebook_pages_shared) !== 'undefined') {
            count_pages_shared = facebook_pages_shared.length;
        }
        return (
            <div className="section distribution-section">
                <div className="section-content distribution">
                    <div className="row platform enabled-platform">
                        <div className="col-xs-7 text-left">
                            <p className="enabled-channel-title">
                                <img style={{width: 15}} src='/img/channels/messenger-icon.svg'/> Facebook messenger
                            </p>
                        </div>
                        <div className="col-xs-5">
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                {(facebook_platform_enabled && (count_pages > 0 || count_pages_shared > 0)) ?
                                    <div>
                                        <p style={{cursor: "pointer"}}><span style={{fontSize: 11}}
                                                                             className='enabled-label'>Enabled </span>
                                            <Popover
                                                interactionKind={PopoverInteractionKind.CLICK}

                                                position={Position.LEFT_TOP}
                                                minimal={true}
                                            >
                                                <span className="fas fa-ellipsis-v"
                                                      style={{color: 'black', marginLeft: 10}}></span>
                                                <div className="three-dots-popover padding-10">
                                                    <a id="team_delete_btn" onClick={this.toggleWP} id="fb_disable"
                                                       title={sourceId} href="#">Disable {this.state.fb_spinner ?
                                                        <i className='fa fa-spin fa-spinner'></i> : ''}</a>
                                                </div>
                                            </Popover></p>

                                    </div>

                                    :
                                    (
                                        (this.state.fb_spinner) ?
                                            <FacebookLogin
                                                appId={facebook_app_id}
                                                autoLoad={false}
                                                return_scopes={true}
                                                fields="name, email, picture"
                                                scope="email, public_profile, pages_messaging, ads_management, pages_read_engagement"
                                                callback={this.responseFacebookForSourceEnable}
                                                render={renderProps => (
                                                    <div className="col-xs-6 align-right">
                                                        <a href="#">
                                                            <div disabled={true} onClick={renderProps.onClick}
                                                                 className="enable-button">
                                                                <p style={{marginRight: '20px'}}>Enable</p> <i style={{
                                                                position: 'absolute',
                                                                right: '10px',
                                                                top: '8px',
                                                            }} className='fa fa-spin fa-spinner'></i>
                                                            </div>
                                                        </a>
                                                    </div>
                                                )}
                                            />
                                            :
                                            <FacebookLogin
                                                appId={facebook_app_id}
                                                autoLoad={false}
                                                return_scopes={true}
                                                fields="name, email, picture"
                                                scope="email, public_profile, pages_messaging, ads_management, pages_read_engagement"
                                                callback={this.responseFacebookForSourceEnable}
                                                render={renderProps => (
                                                    <div onClick={renderProps.onClick}
                                                         className="enable-button align-right">
                                                        <p>Enable</p>
                                                    </div>
                                                )}
                                            />
                                    )
                                }
                            </div>
                        </div>
                        {!this.state.fbManagePagesPermission && (this.state.fbManagePagesPermission !== undefined) ?
                            <p style={{color: 'red', paddingLeft: 10, paddingRight: 10, display: 'inline-block'}}>Manage
                                Pages Permission is needed for getting your pages</p> : ''}
                    </div>
                    {(count_pages > 0 || count_pages_shared > 0) ?
                        <div className="enabled-platform-settings">
                            <div id="fb-pages" data-intercom-target="fb-pages-part">
                                <p className="enabled-title">Pages</p>
                                {(this.state.user.missing_allowed_pages && this.state.user.missing_allowed_pages.length > 0) ?
                                    <div className="missing-allowed-pages-container">
                                        <p>You denied permissions
                                            for {this.state.user.missing_allowed_pages.length > 1 ?
                                                'pages: ' : 'page: '}
                                        </p>
                                        {this.state.user.missing_allowed_pages.length > 1 ?
                                            this.state.user.missing_allowed_pages.map((page) => {
                                                return <p>
                                                    <strong>- {page.page}</strong>
                                                </p>
                                            }) :
                                            <p>
                                                <strong>- {this.state.user.missing_allowed_pages[0].page}</strong>
                                            </p>
                                        }
                                        <p>{this.state.user.missing_allowed_pages.length > 1 ? 'These pages were ' : 'This page was '}
                                            connected to your workspaces. You can give permissions
                                            for {this.state.user.missing_allowed_pages.length > 1 ?
                                                'these pages' : 'this page'} by clicking on Request Denied Permissions
                                            button.</p>
                                    </div> : ''
                                }
                                {(count_pages > 0)
                                    ?
                                    facebook_pages.map(fb_page => (
                                        <div
                                            className={fb_page.page_connected === "Connected" ? "row" : "row"}
                                            key={fb_page.id}>
                                            <div className="col-xs-8">

                                                <p className="fb-page-name">
                                                    <img
                                                        src={"https://graph.facebook.com/" + fb_page.fb_page_id + "/picture"}
                                                        alt="Facebook Page" className="..."/>
                                                    {fb_page.fb_page}
                                                </p>
                                            </div>
                                            {(fb_page.page_connected === "Connected")
                                                ?
                                                <div className="col-xs-4 green align-right">
                                                    {(sourceId === fb_page.feed_id || sourceId === "page_source")
                                                        ?
                                                        <span style={{fontSize: 11}}
                                                              className="enabled-label">Connected</span>
                                                        :
                                                        <p className="text-light-grey">Already connected<br/> to another
                                                            workspace
                                                        </p>
                                                    }

                                                    {
                                                        sourceId === fb_page.feed_id ?
                                                            show_disconnect ?
                                                                <div
                                                                    className="platform-menu platform-edit right d-inline-b">
                                                                    {/*<span*/}
                                                                    {/*slot={fb_page.fb_page_id} id="platform-edit"*/}
                                                                    {/*className="fas fa-ellipsis-v"*/}
                                                                    {/*onClick={this.handleDisconnectShow}></span>*/}
                                                                    <Popover
                                                                        interactionKind={PopoverInteractionKind.CLICK}

                                                                        position={Position.LEFT_TOP}
                                                                        minimal={true}
                                                                    >
                                                                        <span id="feed-edit"
                                                                              className="fas fa-ellipsis-v"
                                                                              style={{right: 15, top: -8}}></span>
                                                                        <div className="project-info-popover padding-10"
                                                                             id={fb_page.fb_page_id}>
                                                                            <a
                                                                                href="# "
                                                                                title={fb_page.page_connected}
                                                                                value={fb_page.page_access_token}
                                                                                id={fb_page.fb_page_id}
                                                                                name={fb_page.feed_id}
                                                                                onClick={() => this.setState({
                                                                                    disconnectPageModalActive: true,
                                                                                    disconnectPageModalData: {
                                                                                        title: fb_page.page_connected,
                                                                                        value: fb_page.page_access_token,
                                                                                        id: fb_page.fb_page_id,
                                                                                        name: fb_page.feed_id
                                                                                    }
                                                                                })}
                                                                                slot={fb_page.fb_page}>Disconnect</a>
                                                                        </div>
                                                                    </Popover>
                                                                    {/*<div*/}
                                                                    {/*className="platform-dropdown platform-disconnect"*/}
                                                                    {/*id={fb_page.fb_page_id}>*/}
                                                                    {/*<a*/}
                                                                    {/*href="# "*/}
                                                                    {/*title={fb_page.page_connected}*/}
                                                                    {/*value={fb_page.page_access_token}*/}
                                                                    {/*id={fb_page.fb_page_id}*/}
                                                                    {/*name={fb_page.feed_id}*/}
                                                                    {/*onClick={openModal}*/}
                                                                    {/*slot={fb_page.fb_page}>Disconnect</a>*/}
                                                                    {/*</div>*/}
                                                                </div>

                                                                :
                                                                ""
                                                            :
                                                            <div id="forbidden"
                                                                 className="team-user forbidden resp-user">
                                                                <InfoCircle
                                                                    infoCircleContent={
                                                                        <p className='info-circle-content'>You can't
                                                                            connect <strong>{fb_page.fb_page}</strong> page,
                                                                            because it is connected to another
                                                                            workspace. <br/>
                                                                            This page is connected
                                                                            to: <br/><strong>{fb_page.feed_name}</strong>
                                                                        </p>
                                                                    }
                                                                />
                                                                {/*<Popover*/}
                                                                {/*interactionKind={PopoverInteractionKind.CLICK}*/}
                                                                {/*popoverClassName="bp3-popover-content-sizing information-circle-popover"*/}
                                                                {/*// position={Position.RIGHT}*/}
                                                                {/*>*/}
                                                                {/*<span*/}
                                                                {/*className="fas fa-info-circle information-circle"*/}
                                                                {/*slot={fb_page.fb_page_id}*/}
                                                                {/*intent={Intent.PRIMARY}></span>*/}
                                                                {/*<div className="team-user-panel right-0" id={fb_page.fb_page_id}>*/}
                                                                {/*<p>You can't disconnect <strong>{ fb_page.fb_page }</strong> page, because it is connected to another workspace. </p>*/}
                                                                {/*<p>This page is connected to: <br/><strong>{ fb_page.feed_name }</strong></p>*/}
                                                                {/*</div>*/}
                                                                {/*</Popover>*/}
                                                            </div>
                                                    }
                                                </div>
                                                :
                                                <div className="col-xs-4 align-right">
                                                    {this.state.spinnerActive && this.state.clickedFbPageConnect === fb_page.fb_page_id ?
                                                        <button
                                                            className="btn-action dist-platf-button"
                                                            disabled={true}>
                                                            <span style={{marginRight: '20px'}}>Connect</span>
                                                            <i
                                                                className='fa fa-spin fa-spinner'
                                                                style={fromDistributionPlatforms ?
                                                                    {
                                                                        position: 'absolute',
                                                                        right: '10px',
                                                                        top: '8px',

                                                                    } : {}}
                                                            ></i>
                                                        </button> :
                                                        <button
                                                            className="btn-action dist-platf-button"
                                                            title={fb_page.page_connected}
                                                            value={fb_page.page_access_token}
                                                            id={fb_page.fb_page_id}
                                                            name={sourceId}
                                                            onClick={this.toggleConnect}
                                                            slot={fb_page.fb_page}>
                                                            Connect
                                                        </button>
                                                    }
                                                </div>
                                            }
                                            <ReactTooltip/>
                                            {(fb_page.page_connected === "Connected") && (fb_page.feed_id === sourceId) ?
                                                fromDistributionPlatforms ?
                                                    <div className="qr-code-container">
                                                        <p>Become your first subscriber to see it in action!<br/></p>
                                                        <p className="text-light-blue">Scan QR code with your
                                                            smartphone.<br/><br/>
                                                        </p>
                                                        <div className="flex-direction-row space-between">
                                                            <div className="col-xs-7 no-padding">
                                                                <p>
                                                                    <img src={'/img/or-line.png'}
                                                                         style={{marginRight: '10px'}}/> or <img
                                                                    src={'/img/or-line.png'}
                                                                    style={{marginLeft: '10px'}}/>
                                                                    <br/><br/></p>
                                                                <p>Open this link in browser <br/>
                                                                    (best experience on mobile).</p>
                                                                <a href={'https://m.me/' + fb_page.fb_page_id}
                                                                   target="_blank">m.me/{fb_page.fb_page_id}</a>
                                                            </div>
                                                            <div className="qr-code-image-container">
                                                                { /*Qr code is displayed as image when url is passed in the format bellow.
                                                                 size defines dimensions and after = sign goes url that is converted to qr code */}
                                                                <img
                                                                    src={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}/>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    <div className="qr-code-container">
                                                        <p><strong>Promote to your audience.</strong></p>
                                                        <br/>
                                                        <div className="flex-direction-row space-between">
                                                            <div className="left-part">
                                                                <div className="flex-direction-row space-between">
                                                                    <a target="_blank" download="qr_code_image.png"
                                                                       href={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}>
                                                                        <p className="text-light-blue">Download QR
                                                                            code.</p>
                                                                    </a>
                                                                    <a target="_blank" download="qr_code_image.png"
                                                                       href={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}>
                                                                        <i className="fa fa-arrow-alt-circle-down qr-code-icons"/>
                                                                    </a>
                                                                </div>
                                                                <p>
                                                                    <img src={'/img/or-line.png'}
                                                                         style={{marginRight: '10px'}}/> or <img
                                                                    src={'/img/or-line.png'}
                                                                    style={{marginLeft: '10px'}}/>
                                                                    <br/><br/></p>
                                                                <p>Copy this link and share it trough your favorite
                                                                    channels.</p>
                                                                <div className="flex-direction-row space-between">
                                                                    <a id="forClipboard" className="text-light-blue"
                                                                       href={'https://m.me/' + fb_page.fb_page_id}
                                                                       target="_blank">m.me/{fb_page.fb_page_id}</a>
                                                                    <i onClick={() => this.copyStringToClipboard('m.me/' + fb_page.fb_page_id)}
                                                                       className="fa fa-copy qr-code-icons"/>
                                                                </div>
                                                            </div>
                                                            <div className="qr-code-image-container">
                                                                { /*Qr code is displayed as image when url is passed in the format bellow.
                                                                 size defines dimensions and after = sign goes url that is converted to qr code */}
                                                                <img
                                                                    src={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}/>
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.copiedToClipboard ?
                                                                <p className="green">Url successfully copied</p> : ''
                                                        }
                                                    </div>
                                                : ''
                                            }
                                        </div>
                                    ))
                                    :
                                    ""

                                }

                                {(facebook_pages_shared && facebook_pages_shared.length > 0)
                                    ?
                                    facebook_pages_shared.map(fb_page => (
                                        <div className={fb_page.connected ? "row" : "row"} key={fb_page.id}>
                                            <div className="col-xs-8">
                                                <p className="fb-page-name">
                                                    <img
                                                        src={"https://graph.facebook.com/" + fb_page.page_id + "/picture"}
                                                        alt="Facebook Page" className="..."/>
                                                    {fb_page.page}
                                                </p>
                                            </div>
                                            {(fb_page.connected)
                                                ?
                                                <div className="col-xs-4 green align-right">
                                                    {(sourceId === fb_page.project_id || sourceId === "page_source")
                                                        ?
                                                        <p className="green">Connected</p>
                                                        :
                                                        <p className="text-light-grey">Already connected<br/> to another
                                                            workspace
                                                        </p>
                                                    }
                                                    <div
                                                        id={(sourceId === fb_page.project_id) || (sourceId === "page_source") ? "forbidden2" : "forbidden"}
                                                        className="team-user forbidden resp-user">
                                                        <InfoCircle
                                                            infoCircleContent={
                                                                <div className="team-user-panel right-0"
                                                                     id={fb_page.fb_page_id}
                                                                     style={{maxWidth: 400}}>
                                                                    <p>You can't
                                                                        disconnect <strong>{fb_page.page}</strong> page,
                                                                        because
                                                                        you are not an admin
                                                                        on this page or you revoked permission for this
                                                                        page.
                                                                    </p>
                                                                    <p>This page was connected by:</p>
                                                                    <div style={{width: '100%', height: 50}}>
                                                                        <div className="col-xs-3"
                                                                             style={{
                                                                                 borderRadius: 50,
                                                                                 overflow: 'hidden',
                                                                                 width: 50,
                                                                                 height: 50,
                                                                                 paddingLeft: 0
                                                                             }}>
                                                                            <img style={{
                                                                                width: 50,
                                                                                height: 50,
                                                                                marginLeft: 0
                                                                            }}
                                                                                 src={fb_page.user.profile_photo !== null ? fb_page.user.profile_photo : '/img/default-user.jpg'}
                                                                                 alt="user"/>
                                                                        </div>
                                                                        <div className="col-xs-9">
                                                                            <div
                                                                                className="team-user-name">{fb_page.user.first_name + " " + fb_page.user.last_name}</div>
                                                                            <div
                                                                                className="team-user-email">{fb_page.user.email}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        />
                                                        {/*<Popover*/}
                                                        {/*interactionKind={PopoverInteractionKind.CLICK}*/}
                                                        {/*popoverClassName="bp3-popover-content-sizing information-circle-popover"*/}
                                                        {/*// position={Position.RIGHT}*/}
                                                        {/*>*/}
                                                        {/*<span*/}
                                                        {/*className="fas fa-info-circle information-circle"*/}
                                                        {/*slot={fb_page.fb_page_id}*/}
                                                        {/*intent={Intent.PRIMARY}></span>*/}
                                                        {/*<div className="team-user-panel right-0" id={fb_page.fb_page_id}>*/}
                                                        {/*<p>You can't*/}
                                                        {/*disconnect <strong>{fb_page.page}</strong> page, because*/}
                                                        {/*you are not an admin*/}
                                                        {/*on this page or you revoked permission for this page.*/}
                                                        {/*</p>*/}
                                                        {/*<p>This page was connected by:</p>*/}
                                                        {/*<div style={{width: '100%', height: 50}}>*/}
                                                        {/*<div className="col-xs-3">*/}
                                                        {/*<img src={fb_page.user.profile_photo} alt="user"/>*/}
                                                        {/*</div>*/}
                                                        {/*<div className="col-xs-9">*/}
                                                        {/*<div*/}
                                                        {/*className="team-user-name">{fb_page.user.first_name + " " + fb_page.user.last_name}</div>*/}
                                                        {/*<div*/}
                                                        {/*className="team-user-email">{fb_page.user.email}</div>*/}
                                                        {/*</div>*/}
                                                        {/*</div>*/}
                                                        {/*</div>*/}
                                                        {/*</Popover>*/}
                                                    </div>

                                                </div>
                                                :
                                                <div className="col-xs-4 align-right">
                                                    <button
                                                        className="btn-action dist-platf-button"
                                                        title={fb_page.connected}
                                                        value={fb_page.access_token}
                                                        id={fb_page.page_id}
                                                        name={sourceId}
                                                        onClick={this.toggleConnect}
                                                        slot={fb_page.page}
                                                    >
                                                        Connect
                                                    </button>
                                                </div>
                                            }
                                            <ReactTooltip/>
                                            {(fb_page.connected) && (fb_page.project_id === sourceId) ?
                                                fromDistributionPlatforms ?
                                                    <div className="qr-code-container">
                                                        <p>Become your first subscriber to see it in action!<br/></p>
                                                        <p className="text-light-blue">Scan QR code with your
                                                            smartphone.<br/><br/>
                                                        </p>
                                                        <div className="flex-direction-row space-between">
                                                            <div className="col-xs-7 no-padding">
                                                                <p>
                                                                    <img src={'/img/or-line.png'}
                                                                         style={{marginRight: '10px'}}/> or <img
                                                                    src={'/img/or-line.png'}
                                                                    style={{marginLeft: '10px'}}/>
                                                                    <br/><br/></p>
                                                                <p>Open this link in browser <br/>
                                                                    (best experience on mobile).</p>
                                                                <a href={'https://m.me/' + fb_page.page_id}
                                                                   target="_blank">m.me/{fb_page.page_id}</a>
                                                            </div>
                                                            <div className="qr-code-image-container">
                                                                { /*Qr code is displayed as image when url is passed in the format bellow.
                                                                 size defines dimensions and after = sign goes url that is converted to qr code */}
                                                                <img
                                                                    src={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}/>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    <div className="qr-code-container">
                                                        <p><strong>Promote to your audience.</strong></p>
                                                        <br/>
                                                        <div className="flex-direction-row space-between">
                                                            <div className="left-part">
                                                                <div className="flex-direction-row space-between">
                                                                    <a target="_blank" download="qr_code_image.png"
                                                                       href={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}>
                                                                        <p className="text-light-blue">Download QR
                                                                            code.</p>
                                                                    </a>
                                                                    <a target="_blank" download="qr_code_image.png"
                                                                       href={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.fb_page_id}>
                                                                        <i className="fa fa-arrow-alt-circle-down qr-code-icons"/>
                                                                    </a>
                                                                </div>
                                                                <p>
                                                                    <img src={'/img/or-line.png'}
                                                                         style={{marginRight: '10px'}}/> or <img
                                                                    src={'/img/or-line.png'}
                                                                    style={{marginLeft: '10px'}}/>
                                                                    <br/><br/></p>
                                                                <p>Copy this link and share it trough your favorite
                                                                    channels.</p>
                                                                <div className="flex-direction-row space-between">
                                                                    <a id="forClipboard" className="text-light-blue"
                                                                       href={'https://m.me/' + fb_page.page_id}
                                                                       target="_blank">m.me/{fb_page.page_id}</a>
                                                                    <i onClick={() => this.copyStringToClipboard('m.me/' + fb_page.page_id)}
                                                                       className="fa fa-copy qr-code-icons"/>
                                                                </div>
                                                            </div>
                                                            <div className="qr-code-image-container">
                                                                { /*Qr code is displayed as image when url is passed in the format bellow.
                                                                 size defines dimensions and after = sign goes url that is converted to qr code */}
                                                                <img
                                                                    src={"https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=m.me/" + fb_page.page_id}/>
                                                            </div>
                                                        </div>
                                                        {
                                                            this.state.copiedToClipboard ?
                                                                <p className="green">Url successfully copied</p> : ''
                                                        }
                                                    </div>
                                                : ''
                                            }
                                        </div>
                                    ))
                                    :
                                    ""
                                }

                            </div>
                            <FacebookLogin
                                appId={facebook_app_id}
                                autoLoad={false}
                                return_scopes={true}
                                fields="name, email, picture"
                                scope="email, public_profile, pages_messaging, ads_management, pages_read_engagement"
                                callback={this.responseFacebookForSource}
                                render={renderProps => (
                                    <div className="row no-border">
                                        <button
                                            id="ask_denied_permissions"
                                            onClick={renderProps.onClick}
                                            className="btn-fb m-m-b"
                                            style={{
                                                float: "right",
                                                marginTop: "10px"
                                            }}>
                                            <span className="fas fa-sync"></span> Request Denied Permissions
                                        </button>
                                    </div>
                                )}/>
                        </div> :
                        <div className="enabled-platform-settings">
                            <div id="fb-pages" data-intercom-target="fb-pages-part">
                                {(this.state.user.missing_allowed_pages && this.state.user.missing_allowed_pages.length > 0) ?
                                    <div className="missing-allowed-pages-container">
                                        <p>You denied permissions
                                            for {this.state.user.missing_allowed_pages.length > 1 ?
                                                'pages: ' : 'page: '}
                                        </p>
                                        {this.state.user.missing_allowed_pages.length > 1 ?
                                            this.state.user.missing_allowed_pages.map((page) => {
                                                return <p>
                                                    <strong>- {page.page}</strong>
                                                </p>
                                            }) :
                                            <p>
                                                <strong>- {this.state.user.missing_allowed_pages[0].page}</strong>
                                            </p>
                                        }
                                        <p>{this.state.user.missing_allowed_pages.length > 1 ? 'These pages were ' : 'This page was '}
                                            connected to your workspaces. You can give permissions
                                            for {this.state.user.missing_allowed_pages.length > 1 ?
                                                'these pages' : 'this page'} by clicking on Request Denied Permissions
                                            button.</p>
                                    </div> : ''
                                }
                            </div>
                        </div>
                    }
                </div>
                <ConnectBotToPageModal
                    showModal={this.state.disconnectPageModalActive}
                    handleClose={() => this.setState({disconnectPageModalActive: false})}
                    toggleConnect={this.toggleConnect}
                    maxWidth={600}
                    history={this.props.history}
                    // page_name={this.state.pageName}
                    sources={this.props.user.sources.data}
                    //feeds_shared={feeds_shared}
                    selectedSource={this.props.sourceId}
                    disconnectPageModalData={this.state.disconnectPageModalData}
                />
            </div>

        )
    }
}

export default FbMessengerChannels;